export const langModals = {
  well: {
    ua: 'Ти молодчина,',
    en: 'Well done!',
  },
  faster: {
    ua: 'але потрібно швидше! Наступного разу тобі все вдасться)',
    en: 'But you need to be a little bit faster. You can do it ;)',
  },
  training: {
    ua: 'Нове тренування',
    en: 'New training',
  },
  back: {
    ua: 'Назад',
    en: 'Back',
  },
 congrat: {
    ua: 'Вітаю!',
    en: 'Congratulations',
    },
 anotherbook: {
    ua: 'Ще одна книга прочитана.',
    en: 'One another book read.',
    },
 done: {
    ua: 'Готово',
    en: 'Done',
    },
 unsaved: {
    ua: 'Якщо Ви вийдете з програми незбережені дані будуть втрачені',
    en: 'If you exit the program, unsaved data will be lost',
    },
 cancel: {
    ua: 'Відміна',
    en: 'Cancel',
    },
 exit: {
    ua: 'Вийти',
    en: 'Exit',
  },
 chooseRating: {
    ua: 'Обрати рейтинг книги',
    en: 'Choose a book rating',
    },
 summary: {
    ua: 'Резюме',
    en: 'Summary',
  },
 save: {
    ua: 'Зберегти',
    en: 'Save',
  },
};